import { ERR_GENERIC_LATER } from '../../constants/response-error-messages';
import { FULFILLMENT_TYPE } from '../../constants/status';
import { pushEventInfo, pushEventInfoWithFulfillment } from '../analytics';
// 1.1 Edit Pickup Person Overlay
export var catchEditDeliveryInstructionsButtonPress = function () {
    pushEventInfo({
        category: { primaryCategory: 'overlay' },
        eventInfo: {
            eventName: 'purchase history: order details: edit delivery instructions',
        },
    });
};
var getFulfillmentTypesPresent = function (fulfillmentType) {
    var sth = false;
    var boss = false;
    var bopis = false;
    var bodfs = false;
    var dfs = false;
    var appliance = false;
    var misc = false;
    switch (fulfillmentType) {
        case FULFILLMENT_TYPE.STH:
            sth = true;
            break;
        case FULFILLMENT_TYPE.BODFS:
            bodfs = true;
            break;
        case FULFILLMENT_TYPE.APPLIANCE:
            appliance = true;
            break;
        case FULFILLMENT_TYPE.DFS:
            dfs = true;
            break;
        case FULFILLMENT_TYPE.BOPIS:
            bopis = true;
            break;
        case FULFILLMENT_TYPE.BOSS:
            boss = true;
            break;
        default:
            misc = true;
            break;
    }
    return {
        sth: sth,
        bodfs: bodfs,
        appliance: appliance,
        dfs: dfs,
        bopis: bopis,
        boss: boss,
        misc: misc,
    };
};
// 1.2 Order Details Delivery Instructions Updated
export var catchEditDeliveryInstructionsUpdated = function (fulfillmentType) {
    var fulfillmentTypes = getFulfillmentTypesPresent(fulfillmentType);
    var settings = "orders:sth:".concat(fulfillmentTypes.sth ? 'y' : 'n', "|boss:").concat(fulfillmentTypes.boss ? 'y' : 'n', "|bopis:").concat(fulfillmentTypes.bopis ? 'y' : 'n', "|bodfs:").concat(fulfillmentTypes.bodfs ? 'y' : 'n', "|appl:").concat(fulfillmentTypes.appliance ? 'y' : 'n', "|unknown:").concat(fulfillmentTypes.misc || fulfillmentTypes.dfs ? 'y' : 'n');
    pushEventInfoWithFulfillment({
        category: { primaryCategory: 'button submission' },
        eventInfo: { eventName: 'my account settings' },
        myAccount: {
            settings: 'purchase history: order details: edit delivery instructions updated',
        },
        fulfillmentType: settings,
    });
};
// 1.4 Post Page Load Error Tracking
export var catchEditDeliveryInstructionsPostPageLoadError = function (errorCode) {
    pushEventInfo({
        category: { primaryCategory: 'error' },
        eventInfo: {
            eventName: 'post page error',
            error: [
                {
                    type: 'advisory',
                    displayType: 'inline',
                    pageSection: 'order details>edit delivery instructions',
                    message: ERR_GENERIC_LATER.message,
                    code: errorCode,
                },
            ],
        },
    });
};
// 1.5 Order Details Pickup Person Updated Button Submission
export var catchButtonDisplayEvent = function () {
    pushEventInfo({
        category: { primaryCategory: 'button submission' },
        eventInfo: {
            eventName: 'my account settings',
        },
        myAccount: {
            settings: 'purchase history: order details: edit delivery instructions button displayed',
        },
    });
};
